export default "__VITE_ASSET__a7f41e54__"